import * as React from 'react';
import { Box, MenuItem, Typography } from '@material-ui/core';
import { DropdownMenu } from '../../../DropdownMenu';
import { ToDoDescriptor } from '../types';
import { useToDoStyles } from '../styles';

type Props = {
  descriptor: ToDoDescriptor;
};

export const ToDoGroupItem: React.FC<Props> = ({ descriptor }) => {
  const classes = useToDoStyles();
  const { label, icon, count, children = [] } = descriptor;
  const styledIcon = React.cloneElement(icon, { className: classes.menuTitleIcon });

  return (
    <DropdownMenu
      title={
        <Box className={classes.menuTitle}>
          {styledIcon}
          <Typography variant="body1">
            {label} ({count})
          </Typography>
        </Box>
      }
    >
      {children.map(child => (
        <MenuItem key={child.id} component="a" href={child.href}>
          {child.label}
        </MenuItem>
      ))}
    </DropdownMenu>
  );
};
